import request from "../utils/request"

const BASE_API = "https://quanlycudan.azurewebsites.net/api";
export function getAllAccountResidentService(params) {
    return request(`${BASE_API}/Residence/get-all-users}`,
    {
        method: 'POST',
        data: params,
    })
}